import React from 'react';
import PropTypes from 'prop-types';
import { X, FileText } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';

function SummaryDialog({ isOpen, declinedSummary, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div
        className="relative bg-background rounded-lg shadow-lg w-full max-w-lg mx-4"
        style={{ border: '1px solid hsl(var(--border))' }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-6 py-4 border-b"
          style={{ borderColor: 'hsl(var(--border))' }}
        >
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-red-500/10">
              <FileText className="h-5 w-5 text-red-500" />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Declined Summary</h2>
              <p className="text-sm text-muted-foreground">Skills that were declined</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-4">
          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-sm text-foreground whitespace-pre-line leading-relaxed">
              {declinedSummary}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div
          className="flex justify-end px-6 py-4 border-t"
          style={{ borderColor: 'hsl(var(--border))' }}
        >
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>
    </div>
  );
}

SummaryDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  declinedSummary: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SummaryDialog;
